<h3 class="text-lg text-bold">Store</h3>
<soft-json-object-tree class="text-sm overflow-auto mt-2 max-h-[85vh]"
                       [value]="state()" name="Store" [expanded]="true" [canToggle]="false"></soft-json-object-tree>
